/**
 * 商城会员
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//基本信息编辑
import MallMemberEdit from './MallMemberEdit';
//商户下属用户维护
import MemberTeam from '../member/MemberTeam';
//充值
import MemberRecharge from '../member/MemberRecharge';
//扣款
import MemberDeduction from '../member/MemberDeduction';
//退款
import MemberRefund from '../member/MemberRefund';
//详情
import MemberDetail from '../member/MemberDetail';
import messager from '../../ui/messager';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth'

class MemberIndex extends React.Component {

    columns = [{
        title: '会员名称',
        dataIndex: 'name',
        width: '14%',
    }, {
        title: '证件号码',
        dataIndex: 'creditNo',
        width: '14%',
    }, {
        title: '地址',
        dataIndex: 'address',
        width: '20%',
    }, {
        title: '联系人',
        dataIndex: 'contactMan',
        width: '10%',
    }, {
        title: '联系电话',
        dataIndex: 'contactNumber',
        width: '10%',
    }, {
        title: '内部会员',
        dataIndex: 'internalMember',
        width: '5%',
        format: { 0: "否", 1: "是" }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("MALL_MEMBER_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MALL_MEMBER_MEMBER")?
                <Tooltip title="会员下用户配置">
                    <Icon type="team" className="table-operate-icon" onClick={this.updateTeam.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MALL_MEMBER_COOPERATE")&&record.internalMember !== 1 ?
                    <Tooltip title="设置为公司内部会员">
                        <Icon type="user-add" className="table-operate-icon" onClick={this.updateInternal.bind(this, record, 1)} />
                    </Tooltip>
                :""}
                {global_data.authCode.includes("MALL_MEMBER_CANCEL_COOPERATE")&&record.internalMember === 1 ?
                        <Tooltip title="移除公司内部会员">
                            <Icon type="user-delete" className="table-operate-icon" onClick={this.updateInternal.bind(this, record, 0)} />
                        </Tooltip>
                :""}
                {global_data.authCode.includes("MALL_MEMBER_RECHARGE")?
                <Tooltip title="充值">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.doRecharge.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MALL_MEMBER_DEDUCTION")?
                <Tooltip title="扣款">
                    <Icon type="transaction" className="table-operate-icon" onClick={this.deduction.bind(this, record)} />
                </Tooltip>
                :""}
                <Tooltip title="明细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {
            mall: 1,    //只查询商城会员
            state: 0,
        },
        teamVisible: false,
        rechargeVisible: false,
        refundVisible: false,
        deductionVisible: false,
        detailVisible: false,
        summary: {},

    };


    add = () => {
        this.setState({ editData: {}, visible: true });
    }

    update = (info, e) => {
        http.post({
            url: '/mallMember/getMemberImage',
            data: { code: info.code },
            success: (res) => {
                info.image=res.image
                info.imageUrl=res.imageUrl
                if(res.imageUrl!==undefined){
                    info.mallDesc=res.imageUrl.mallDesc
                }
                this.setState({ editData: info, visible: true });
                this.initEdit(info);

            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    //会员下的人员设置
    updateTeam = (info, e) => {
        this.refs["memberTeam"].initData(info.code,
            (res) => { this.setState({ editData: info, teamVisible: true }) }
        );
    }

    /**
     * 修改商城会员是否为内部员工状态
     */
    updateInternal = (info, internalMember, e) => {
        let msg = "是否将该会员移出内部会员？";
        if(internalMember === 1){
            msg = "是否将该会员设置为内部会员？如果设置了，该会员提交的车辆数据会同步到金蝶系统。";
        }
        messager.confirm(msg, () => {
            http.post({
                url: '/mallMember/updateInternalMember',
                data: { "code": info.code, "internalMember": internalMember },
                success: (res) => {
                    this.state.loadData(this.state.queryData)
                    messager.notify("操作成功！");
                }
            });
        });
    }

    //充值
    doRecharge = (info, e) => {
        this.setState({ editData: info, rechargeVisible: true });
    }
    //扣费
    deduction = (info, e) => {
        this.setState({ editData: info, deductionVisible: true });
    }
    //退款
    doRefund = (info, e) => {
        this.setState({ editData: info, refundVisible: true });
    } //详情
    detail = (info, e) => {
        //查询当前账户的汇总信息
        http.post({
            url: '/mallMember/findAccountRecordSummary',
            data: { memberCode: info.code },
            success: (res) => {
                this.setState({ summary: res, editData: info, detailVisible: true });
                this.refs["detail"].loadTableData(info.code, "account");
                this.refs["detail"].loadTableData(info.code, "bond");
            }
        });
    }


    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400 }}
                                />
                                <OrgSelect style={{ width: '200px', marginLeft: "10px" }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                            {global_data.authCode.includes("MALL_MEMBER_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                            :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/mallMember/findMemberPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                    initParams={this.state.queryData}
                />
                <MallMemberEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    initFunc={(func) => { this.initEdit = func }}
                />
                <MemberTeam
                    visible={this.state.teamVisible}
                    onCancel={() => { this.setState({ teamVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    ref="memberTeam"
                    content="mallMember"
                />
                <MemberRecharge
                    visible={this.state.rechargeVisible}
                    onCancel={() => { this.setState({ rechargeVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="mallMember"
                />
                <MemberRefund
                    visible={this.state.refundVisible}
                    onCancel={() => { this.setState({ refundVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="mallMember"
                />
                <MemberDeduction
                    visible={this.state.deductionVisible}
                    onCancel={() => { this.setState({ deductionVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="mallMember"
                />
                <MemberDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    summary={this.state.summary}
                    ref="detail"
                    content="mallMember"
                />
            </div>
        )
    }
}

export default MemberIndex;